import {ReactNode} from "react"

export default function FormSectionHeading({children}: {children: ReactNode}) {
    return <div className="form-section-heading">{children}</div>
}
